import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import orderBy from 'lodash/orderBy';
import keyBy from 'lodash/keyBy';
import defaultTo from 'lodash/defaultTo';
import { pending } from 'redux-saga-thunk';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { notification } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import CpCheckinsForm from '../components/molecules/CpCheckinsForm';
import { createValidator, required, url } from '../services/validation';
import {
  resourceListReadRequest,
  resourceDeleteRequest,
  resourceUpdateSuccess,
  resourceUpdateRequest,
  resourceCreateRequest,
} from '../store/resource/actions';
import { fromEntities, fromResource } from '../store/selectors';

class CpCheckinsFormContainer extends Component {
  componentDidMount() {
    this.props.getCpCheckins().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve CP Checkins.',
        duration: 0,
      })
    );
  }

  handleMoveCpCheckin = children => {
    if (!Array.isArray(children)) return;

    const cpCheckinList = keyBy(this.props.cpCheckinList, 'action_media_id');

    const re = [];
    children.forEach((cpCheckin, index) => {
      re.push({
        ...cpCheckinList[cpCheckin],
        priority: index,
      });
    });

    re.forEach(checkin => {
      this.props.change(`creative[${checkin.action_media_id}][priority]`, checkin.priority);

      this.props.updateEntity('advertiser-ad/:lineItemId/checkin/creative/:id', checkin, {
        data: checkin,
        needle: { id: checkin.action_media_id },
      });
    });
  };

  handleRemoveCpCheckin = index => {
    const { cpCheckinList } = this.props;
    const actionMediaId = cpCheckinList[index].action_media_id;

    this.props.deleteCpCheckin(actionMediaId).catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not remove CP Checkin.',
        duration: 0,
      })
    );
  };

  render() {
    return (
      <CpCheckinsForm
        handleRemoveCpCheckin={this.handleRemoveCpCheckin}
        handleMoveCpCheckin={this.handleMoveCpCheckin}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  const cpCheckinList = orderBy(
    fromEntities.getList(
      state,
      'advertiserAdCheckinCreative',
      fromResource.getList(state, 'advertiserAdCheckinCreative')
    ),
    'priority'
  );

  return {
    loading:
      pending(state, 'advertiserAdCheckinCreativeListRead') ||
      pending(state, 'adveriserAdCheckinCreativeDelete') ||
      pending(state, 'advertiserAdCheckinUpdate'),
    cpCheckinList,
    initialValues: { creative: keyBy(cpCheckinList, 'action_media_id') },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  change: (field, value) => dispatch(change('CpCheckinsForm', field, value)),
  updateEntity: (resource, detail, request) =>
    dispatch(resourceUpdateSuccess(resource, detail, request, {})),
  getCpCheckins: () =>
    dispatch(
      resourceListReadRequest(
        'advertiser-ad/:id/checkin/creative',
        { page_size: 100 },
        { id: lineItemId }
      )
    ),
  deleteCpCheckin: actionMediaId =>
    dispatch(
      resourceDeleteRequest('advertiser-ad/:lineItemId/checkin/creative/:id', {
        lineItemId,
        id: actionMediaId,
      })
    ),
  addCreatives: data =>
    dispatch(
      resourceCreateRequest('advertiser-ad/:lineItemId/checkin/creative', { lineItemId }, data)
    ),
  updateCpCheckin: data => {
    return dispatch(
      resourceUpdateRequest(
        'advertiser-ad/:lineItemId/checkin/creative/:id',
        { lineItemId, id: data.action_media_id },
        {
          ...data,
          budget: get(data, 'budget') === '' ? null : get(data, 'budget'),
          rate_type: defaultTo(get(data, 'rate_type'), 'daily'),
        }
      )
    );
  },
});

const validate = createValidator({
  creative: createValidator({ creative_url: [url, required] }),
});

const onSubmit = (values, dispatch, props) => {
  const priorities = orderBy(values.creative, 'priority');
  let lastP = get(priorities[Object.keys(priorities).length - 1], 'priority');
  if (!isEmpty(values.creative_service_id)) {
    const ids = values.creative_service_id.map(id => ({
      creative_service_id: parseInt(id, 10),
      priority: (lastP += 1),
    }));
    return props
      .addCreatives(ids)
      .then(() => {
        notification.success({
          message: 'Success',
          description: 'Your creatives have been added.',
          duration: 4,
        });
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not add creatives.',
          duration: 0,
        })
      );
  }

  return Promise.all(Object.values(values.creative).map(props.updateCpCheckin))
    .then(() => {
      notification.success({
        message: 'Success',
        description: 'Your CP Checkin has been updated.',
        duration: 4,
      });
    })
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not update CP Checkins.',
        duration: 0,
      })
    );
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'CpCheckinsForm',
    enableReinitialize: true,
    onSubmit,
    validate,
  })
)(CpCheckinsFormContainer);
